import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Undo2 } from 'lucide-react';
import { ExportPanel } from '../../../components/accounting/ExportPanel';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LABELS = { transport_invoices: 'Transport', atelier_invoices: 'Atelier', payments: 'Paiements', expenses: 'Dépenses', supplier_invoices: 'Fournisseurs', inventory_movements: 'Inventaire' };

const HistoryRow = ({ e, onRelease }) => (
  <div className="flex flex-wrap items-center gap-x-6 gap-y-1 px-4 py-3 text-sm" data-testid={`export-history-${e.id}`}>
    <span className="text-slate-400 w-32">{e.created_at.slice(0, 16).replace('T', ' ')}</span>
    <span className="text-white flex-1 min-w-[10rem]">{e.template_name} <span className="text-slate-500 uppercase text-xs">{e.format}</span></span>
    <span className="text-slate-400">{e.date_from} → {e.date_to}</span>
    <span className="text-slate-400">{e.sources.map(s => LABELS[s] || s).join(', ')}</span>
    <span className="text-slate-300">{e.documents} doc.</span>
    <span className="text-slate-400 w-48 truncate" title={e.by}>{e.by}</span>
    {e.marked > 0 ? (
      <button onClick={() => onRelease(e)} className="flex items-center gap-1 text-xs text-amber-400 hover:text-amber-300" data-testid={`export-release-${e.id}`}>
        <Undo2 size={13} /> Libérer {e.marked}
      </button>
    ) : <span className="text-xs text-slate-600 w-20">{e.released_at ? 'Libéré' : 'Non marqué'}</span>}
  </div>
);

export const AccountingExportsTab = ({ token }) => {
  const [history, setHistory] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const headers = { Authorization: `Bearer ${token}` };
  const load = () => axios.get(`${API_URL}/api/accounting/exports`, { headers }).then(r => setHistory(r.data)).catch(() => {});
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const release = async (e) => {
    if (!window.confirm(`Libérer les ${e.marked} document(s) de cet export ? Ils redeviendront « à exporter ».`)) return;
    try {
      await axios.delete(`${API_URL}/api/accounting/exports/${e.id}/marks`, { headers });
      toast.success('Documents libérés'); load(); setRefreshKey(k => k + 1);
    } catch { toast.error('Impossible de libérer cet export'); }
  };

  return (
    <div className="space-y-6" data-testid="accounting-exports-tab">
      <ExportPanel baseUrl={`${API_URL}/api/accounting`} headers={headers} onExported={load} refreshKey={refreshKey} />
      <section>
        <h3 className="text-sm font-semibold text-slate-300 mb-2">Historique des exports</h3>
        <div className="bg-slate-900 border border-slate-800 rounded-xl divide-y divide-slate-800">
          {history.map(e => <HistoryRow key={e.id} e={e} onRelease={release} />)}
          {!history.length && <p className="px-4 py-6 text-slate-500 text-sm text-center">Aucun export pour l'instant</p>}
        </div>
      </section>
    </div>
  );
};
